import { useContext } from 'react';
import { WarningsContext } from '../contexts/WarningsContext';

const useWarnings = () => useContext(WarningsContext);

export default useWarnings;
